import { createElementBlock as t, openBlock as l, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function n(c, e) {
  return l(), t("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "m3.823 4 9.159 13.091L3.646 28h3.528l7.386-8.654L20.615 28h7.88l-9.597-13.737L27.658 4h-3.473l-6.857 8.013L11.732 4z"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
